import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import tiendaSinFoto from '../../img/tiendaSinFoto.jpg'
import * as tiendasOficialesService from '../servicios/tiendasOficialesService.js'
import tiendaStyles from './TiendasOficiales.module.css'

const TiendaOficial = ({ tienda, onClick }) => {
  const [logoSrc, setLogoSrc] = useState(null)

  useEffect(() => {
    if (!tienda.idTiendaOficial || !tienda.idAdjuntoLogo) {
      return
    }

    let cancelled = false
    let blobUrl

    tiendasOficialesService
      .buscarImagenPorAdjunto(tienda.idTiendaOficial, tienda.idAdjuntoLogo)
      .then(({ data }) => {
        if (cancelled) {
          return
        }
        blobUrl = URL.createObjectURL(data)
        setLogoSrc(blobUrl)
      })
      .catch(() => {})
    return () => {
      cancelled = true
      if (blobUrl) {
        URL.revokeObjectURL(blobUrl)
      }
    }
  }, [tienda.idTiendaOficial, tienda.idAdjuntoLogo])

  return (
    <div
      className={tiendaStyles.cardTienda}
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          onClick()
        }
      }}
    >
      <div className={tiendaStyles.logoContainer}>
        <img
          className={tiendaStyles.logoTienda}
          src={logoSrc || tiendaSinFoto}
          alt={tienda.nombreTienda}
        />
      </div>
      <p className={tiendaStyles.nombreTienda}>{tienda.nombreTienda}</p>
    </div>
  )
}

TiendaOficial.propTypes = {
  tienda: PropTypes.shape({
    idTiendaOficial: PropTypes.number,
    idAdjuntoLogo: PropTypes.number,
    nombreTienda: PropTypes.string
  }).isRequired,
  onClick: PropTypes.func.isRequired
}

export default TiendaOficial
